export default __webpack_public_path__ + "static/network-755e7f6cab32a379924af8f6c0fd178d.png";